module.exports = __webpack_public_path__ + "static/media/loader.11ac0fcb.svg";